import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { RootState, actions } from '../store';
import {
  IonRefresher, IonRefresherContent, withIonLifeCycle,
  IonInfiniteScroll, IonInfiniteScrollContent,
  IonPage, IonCardContent, IonLoading,
  IonCard, IonAlert, IonCol, IonGrid, IonRow,
  IonBackButton, IonButtons, IonContent,
  IonHeader, IonTitle, IonToolbar,
} from '@ionic/react';
import { Token } from '../store/users/types';

type Props = RouteComponentProps<{ id: string, tab: string }> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps> & {
  goBack: () => void
};

type State = {
  showAlert: boolean,
  question: string,
  message: string,
  showModal: boolean,
};

class Photos extends React.Component<Props, State> {
  defaultState: State = {
    showAlert: false,
    question: '',
    message: '',
    showModal: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.defaultState
    };
    this.props.getParkPhotosByCode(this.props.tokens, this.props.match.params.id);
  }

  // async ionViewDidEnter() {
  //   if (this.props.tokens && this.props.tokens.id_token) {
  //     return;
  //   }
  //   const tokens: Token = await localForage.getItem('tokens');
  //   const todayTime = new Date().getTime();
  //   if (tokens && tokens.refresh_token) {
  //     if (!tokens.expired_at || tokens.expired_at < todayTime) {
  //       this.props.refreshTokens(tokens.refresh_token);
  //     } else {
  //       this.props.setTokens(tokens);
  //     }
  //   }
  // }

  componentDidMount() {
    const { match } = this.props;
    const parkCode = match.params.id;
  }

  doRefresh = (e: CustomEvent) => {
    const { match, getParkPhotosByCode, tokens } = this.props;
    const parkCode = match.params.id;
    getParkPhotosByCode(tokens, parkCode);
    e && (e.target as any).complete();
  }

  loadMorePhotos = (event: CustomEvent<void>) => {
    const { match, getParkPhotosByCode, loadedPhotosInfo, tokens } = this.props;
    const { nextKey } = loadedPhotosInfo;
    const parkCode = match.params.id;
    getParkPhotosByCode(tokens, parkCode, nextKey);
  }

  dismissAlert() {
    this.setState({
      ...this.state,
      showAlert: false,
    });
    this.props.updateApiError('');
  }

  dismissModal = () => {
    this.setState(() => ({
      showModal: false,
    }));
  };

  openPhotoDetails = (photoId: string) => {
    console.log(this.props.match, '---------xxxx--')
    this.props.history.push(`${this.props.match.url.replace('/myphotos','/photos')}/${photoId}`);
  };

  render() {
    const { match, parkMap, actionLoading, photosLoading, loadedPhotosInfo, loadedPhotos, apiError } = this.props;
    const parkCode = match.params.id;
    const park = parkMap[parkCode] || {};
    const parkName = park.name;
    const hasPhotos = !loadedPhotos || loadedPhotos.length === 0;
    return (
      <>
      <IonAlert
        isOpen={!!apiError || this.state.showAlert}
        onDidDismiss={() => this.dismissAlert()}
        header={'Alert'}
        message={apiError || this.state.message}
        buttons={['OK']}
      />
      <IonLoading
        isOpen={actionLoading}
        message={'Please wait...'}
        duration={3000}
      />
      <IonPage className="questions">
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref={`/${match.params.tab}/${match.params.tab}/${parkCode}`} />
            </IonButtons>
            <IonTitle>{parkName} Photos</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonRefresher closeDuration="2000ms" slot="fixed" onIonRefresh={(e: CustomEvent) => this.doRefresh(e)}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>
          <IonCard>
            <IonCardContent>
              {
                hasPhotos ?
                <>No photos found. Be the first to add a photo.</>
                :  
                <IonGrid>
                  <IonRow>
                    {this.props.loadedPhotos && this.props.loadedPhotos.map((item: any, index: number) => {
                      const val = `url(${item.url}), url('../../../assets/img/not-found.png')`;
                      return (
                        <IonCol key={index} size-lg="4" size-md="4" size-sm="4" size-xs="4">
                          <div onClick={() => this.openPhotoDetails(item.id)} className="image-container" style={{"backgroundImage": val, "backgroundSize": "100% 100%", "backgroundRepeat": "no-repeat"}}></div>
                        </IonCol>
                      )
                    })}
                  </IonRow>
                </IonGrid>
              }
              <IonInfiniteScroll
                threshold="200px"
                disabled={!loadedPhotosInfo.nextKey}
                onIonInfinite={this.loadMorePhotos}>
                <IonInfiniteScrollContent
                  loadingSpinner="bubbles"
                  loadingText="Loading more photos..." />
              </IonInfiniteScroll>
            </IonCardContent>
          </IonCard>
        </IonContent>
      </IonPage>
      </>
    );
  }
}

const mapDispatchToProps = {
  updateApiError: (apiError: string) => actions.questions.updateApiError(apiError),
  getParkPhotosByCode: (tokens: Token, parkCode: string, nextKey?: string) => actions.photos.getUserParkPhotosByCode(tokens, parkCode, nextKey),
}

const mapStateToProps = (state: RootState) => ({
  tokens: state.users.tokens,
  apiError: state.photos.apiError,
  parkMap: state.places.parkMap,
  loading: state.photos.loading,
  actionLoading: state.photos.actionLoading,
  photosLoading: state.photos.photosLoading,
  loadedPhotos: state.photos.userLoadedPhotos.photos,
  loadedPhotosInfo: state.photos.userLoadedPhotos,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  )(withIonLifeCycle(Photos));
